import { createAction, createSlice } from '@reduxjs/toolkit';

export const loadCompanyInfoRequest = createAction('companyInfo/loadCompanyInfoRequest');

const initialState = {
    info: {},
    loading: false,
    error: null,
    loaded: false,
    lastFetchTime: null
};

const companyInfoSlice = createSlice({
    name: 'companyInfo',
    initialState,
    reducers: {
        fetchCompanyInfoStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchCompanyInfoSuccess(state, action) {
            state.loading = false;
            state.loaded = true;
            state.error = null;
            state.info = action.payload;
            state.lastFetchTime = new Date().getTime();
        },
        fetchCompanyInfoFailure(state, action) {
            state.loading = false;
            state.error = action.payload;
        }
    }
});

export const { 
    fetchCompanyInfoStart, 
    fetchCompanyInfoSuccess, 
    fetchCompanyInfoFailure 
} = companyInfoSlice.actions;

export default companyInfoSlice.reducer;
